import _ from 'lodash';

import { CONFIG } from 'constants/index';
import { ApiResponse } from 'endpoints/endpoint';
import { renameFile } from 'utils/index';
import { lead } from 'endpoints/index';

import api from '..';

export const leadApi = api.injectEndpoints({
  endpoints: (builder) => ({
    createLead: builder.mutation<ApiResponse<lead.CreateResult, lead.CreateError>, lead.CreateParams>({
      queryFn: (params) => {
        return new Promise((resolve, reject) => {
          const formData = new FormData();

          if (params.parents) formData.append('parents', params.parents);
          if (params.children) formData.append('children', params.children);
          if (params.grandParents) formData.append('grandParents', params.grandParents);
          if (params.address) formData.append('address', params.address);
          if (params.phone) formData.append('phone', params.phone);
          if (params.email) formData.append('email', params.email);
          if (params.tripFeedback) formData.append('tripFeedback', params.tripFeedback);
          if (params.socialLink) formData.append('socialLink', params.socialLink);
          if (params.media) formData.append('media', renameFile(params.media, 'media'));
          if (params.confirmation) formData.append('confirmation', params.confirmation);

          const request = new XMLHttpRequest();
          const { method, url } = lead.update(params).args;

          request.onload = () => {
            try {
              const response = JSON.parse(request.response);
              resolve({ data: response as ApiResponse<lead.CreateResult, lead.CreateError> });
            } catch (e) {
              reject(e);
            }
          };
          request.open(method, `${CONFIG.api}${url}`);
          request.send(formData);
        });
      },
    }),
  }),
  overrideExisting: false,
});
